/* eslint-disable no-unused-vars */
import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Calendar,
  Video,
  Headphones,
  Users,
  BookOpen,
  Heart,
  DollarSign,
  Sparkles,
  MessageCircle,
  Mic,
  ExternalLink,
  Brain,
  Dumbbell,
  Compass,
  Landmark,
  ArrowRight,
  Check,
  Flame,
  CalendarCheck,
  Quote,
} from 'lucide-react';
import PortalSubPage, { ComingSoonCard } from '../PortalSubPage';
import {
  NEXT_MEETING,
  INTEREST_MAILTO,
  INTEREST_EMAIL,
  CIRCLE_FOCUS,
  CIRCLE_GUEST_SPEAKER,
  CIRCLE_TOPICS,
  CIRCLE_PRICE,
  getReflectionForOffset,
} from '../../data/portalData';

export function PortalCommunity() {
  return (
    <PortalSubPage
      eyebrow="Brotherhood"
      title={<>Where the brothers <span className="italic text-[#D4AF37]">gather.</span></>}
      intro="A private space to check in, ask for help, share wins, and stay connected between meetings."
      icon={Users}
    >
      <ComingSoonCard note="We're setting up a private Discord for the brotherhood. You'll receive an invite by email once it launches." />
      <div className="rounded-2xl bg-[#111111] border border-white/10 p-6">
        <h3 className="font-cormorant text-2xl font-medium text-white mb-3">
          In the meantime
        </h3>
        <ul className="space-y-2 text-zinc-300 font-manrope text-sm">
          <li className="flex items-start gap-2">
            <MessageCircle className="w-4 h-4 text-[#D4AF37] mt-0.5" />
            Text <a href="sms:804-310-7433" className="text-[#D4AF37] hover:underline">(804) 310-7433</a> to be added to the WhatsApp brotherhood
          </li>
          <li className="flex items-start gap-2">
            <MessageCircle className="w-4 h-4 text-[#D4AF37] mt-0.5" />
            Join us live at the next monthly meeting
          </li>
        </ul>
      </div>
    </PortalSubPage>
  );
}
